export function valuesHasRow(row) {
    const entries = Object.entries(row);
    return (pattern) => {
        if (pattern.type === 'values') {
            return pattern.values.some(other => {
                return entries.every(([key, value]) => {
                    var _a;
                    return (_a = other[key]) === null || _a === void 0 ? void 0 : _a.equals(value);
                });
            });
        }
        return false;
    };
}
